export interface Product {
  id: number;
  title: string;
  images: string[];  // array cu numele fișierelor în /public/products
  link: string;
  shortDesc: string;
  popularityIndex: number;
  averageRating: number;
  dateAdded: string; // ISO format
  price: number;
  description: string;
}

const productData: Product[] = [
  {
    id: 10,
    title: "3D Pro Zir Multilayer Zirconia",
    images: ["logo-placeholder.png"],
    link: "/product/3d-zirconia",
    shortDesc: "High strength multilayer zirconia for top aesthetics and durability.",
    popularityIndex: 3,
    averageRating: 5.0,
    dateAdded: "2025-07-12",
    price: 800,
    description: `3D Pro Zir Multilayer Zirconia.`,
  },
  {
    id: 1,
    title: "Dental Model Full Arch",
    images: ["full-arch.jpg", "full-arch1.jpg", "full-arch2.jpg"],
    link: "/product/full-arch",
    shortDesc: "...",
    popularityIndex: 4,
    averageRating: 3.2,
    dateAdded: "2025-06-10",
    price: 150,
    description: `Dental model serves as a valuable tool for dentists, orthodontists, and dental technicians, providing a physical representation of the patient’s dental anatomy. It allows for a closer examination of the teeth, gums, and surrounding structures, aiding in treatment planning, diagnosis, and the fabrication of various dental appliances.`,
  },
  
  {
    id: 2,
    title: "Michigan Splint",
    images: ["michigan-splint.jpg", "michigan-splint1.jpg"],
    link: "/product/michigan-splint",
    shortDesc: "...",
    popularityIndex: 10,
    averageRating: 4.0,
    dateAdded: "2025-06-30",
    price: 950,
    description: `Dentists use the Michigan splint as a custom oral appliance to address TMD disorders. The carefully crafted design of the splint helps alleviate symptoms, protect teeth, and promote proper jaw function, ultimately improving the patient’s oral health and overall well-being. Patients can easily remove the splint, allowing for daily cleaning and maintenance. Dental professionals recommend regular follow-up visits to monitor progress, make necessary adjustments, and ensure optimal therapeutic benefits.`,
  },
  {
    id: 3,
    title: "Dental Model Partial Arch",
    images: ["partial-arch.jpg"],
    link: "/product/partial-arch",
    shortDesc: "...",
    popularityIndex: 2,
    averageRating: 3.1,
    dateAdded: "2025-05-20",
    price: 90,
    description: `Dental model serves as a valuable tool for dentists, orthodontists, and dental technicians, providing a physical representation of the patient’s dental anatomy. It allows for a closer examination of the teeth, gums, and surrounding structures, aiding in treatment planning, diagnosis, and the fabrication of various dental appliances.`,
  },
  {
    id: 4,
    title: "Special Trays",
    images: ["special-trays.jpg", "special-trays1.jpg"],
    link: "/product/special-trays",
    shortDesc: "...",
    popularityIndex: 6,
    averageRating: 4.5,
    dateAdded: "2025-06-15",
    price: 400,
    description: ``,
  },
  {
    id: 5,
    title: "Surgical Guide Full Arch",
    images: ["surgical-guide-full.jpg"],
    link: "/product/surgical-guide-full",
    shortDesc: "...",
    popularityIndex: 9,
    averageRating: 4.2,
    dateAdded: "2025-06-25",
    price: 850,
    description: `Surgical guide is a precise and customized tool used during dental implant surgery. The pre-made holes or channels indicate the exact locations and angles for accurate implant placement, minimizing the risk of errors and complications. The use of surgical guides offers several advantages, including enhanced precision, reduced surgery time, and improved patient outcomes. They also promote faster healing and improved post-operative comfort for the patient.`,
  },
  {
    id: 6,
    title: "Surgical Guide Partial Arch",
    images: ["surgical-guide-partial.jpg", "surgical-guide-partial1.jpg"],
    link: "/product/surgical-guide-partial",
    shortDesc: "...",
    popularityIndex: 1,
    averageRating: 3.0,
    dateAdded: "2025-05-10",
    price: 130,
    description: `Surgical guide is a precise and customized tool used during dental implant surgery. The pre-made holes or channels indicate the exact locations and angles for accurate implant placement, minimizing the risk of errors and complications. The use of surgical guides offers several advantages, including enhanced precision, reduced surgery time, and improved patient outcomes. They also promote faster healing and improved post-operative comfort for the patient.`,
  },
  {
    id: 7,
    title: "Surgical Stent",
    images: ["surgical-stent.jpg", "surgical-stent1.jpg"],
    link: "/product/surgical-stent",
    shortDesc: "...",
    popularityIndex: 5,
    averageRating: 3.9,
    dateAdded: "2025-06-22",
    price: 250,
    description: `The surgical stent is an appliance that surgeons use during surgical procedures to locate the optimal site for implant placement. We print the stent from a durable material that ensures patient comfort and safety throughout the procedure. This reduces the potential for errors and enhances surgical accuracy.`,
  },
  {
    id: 8,
    title: "Zirconia Crowns",
    images: ["zirconia-crown.jpg"],
    link: "/product/zirconia-crown",
    shortDesc: "...",
    popularityIndex: 7,
    averageRating: 4.8,
    dateAdded: "2025-07-01",
    price: 600,
    description: ``,
  },
  {
    id: 9,
    title: "Temporary Crowns",
    images: ["temp-crowns.jpg", "temp-crowns1.jpg"],
    link: "/product/temporary-crowns",
    shortDesc: "...",
    popularityIndex: 8,
    averageRating: 4.6,
    dateAdded: "2025-06-18",
    price: 120,
    description: `A temporary crown is a tooth-shaped cap that protects the tooth or implant during the production of the permanent crown. The crown protects against bacteria and secures the tooth or implant. Without a temporary crown, the tooth may shift, meaning that the permanent crown will not fit properly. Because temporary crowns are more delicate than permanent ones, it’s important to take extra care when flossing or chewing while you have a temporary crown in place.`,
  },
];

export default productData;
